var fowtr_module_analytics = (function(fowtr_module_analytics) {

  fowtr_module_analytics.currentChapter = 1;

  // try {
  //   dataLayer.page.pageInfo.pageName = 'Future of Work Trend Reports';
  // } catch(e) {
  //   console.log('dataLayer not found');
  // }


  function tracking_adobe(name,type,interaction,position){
    // adobe
    //     name: "<Name of the content that has been interacted with, like the name of a button or video>",
    //     type: "<Type of the content, like 'Video' or 'Button'>",
    //     interaction: "<Name of the interaction, like 'Click' or 'Play'>",
    //     position: "<Position of content on the page, especially if the same content appears multiple times, like 'Top', 'Bottom', "First", "Last", etc.>"
    var detailParams = { content:
      {
        'name': name,
        'type': type,
        'interaction': interaction,
        'position': position
      }
    }
    // console.log('Adobe tracking: '+name,detail.content);
    // console.log('Tracking: '+name,detail.content);
    // var event = new CustomEvent('dhl_utf_contentInteraction', { bubbles: true, detail: {content: {name:"Subscribe",type:"Button",position:"Top",interaction:"Click"}}});
    // var adobeEvent = new CustomEvent('dhl_utf_contentInteraction', { bubbles: true, detail: { content: {name:"Test1",type:"Test2",position:"Test3",interaction:"Test4" }}});
    var adobeEvent = new CustomEvent('dhl_utf_contentInteraction', { bubbles: true, detail: detailParams});
    window.dispatchEvent(adobeEvent);
    // console.log('Adobe tracking',adobeEvent);
    // console.log('Adobe Tracking:','name:'+name+', type:'+type+' ,interaction:'+interaction+', position:'+position);
    console.log('Adobe Tracking:',name+', '+type+', '+interaction+', '+position);


    // window.dispatchEvent(new CustomEvent('dhl_utf_contentInteraction', { bubbles: true, detail: { content:{name: 'name',type: 'type',interaction: 'interaction',position: 'position'}}}));
    // window.dispatchEvent(new CustomEvent('dhlglobalrolloutprod', { bubbles: true, detail: { content:{name: 'name',type: 'type',interaction: 'interaction',position: 'position'}}}));
    // decibel
    // console.log('Decibel tracking: '+name,{"name":name, "type":"SPA","scope":"FoW Trend Report"});


    // var decibelEvent = new CustomEvent('dhl_utf_trackDecibelEvent', { bubbles: true, detail: {"decibel":{"event":{"name":(name+' - type:'+type+' - interaction:'+interaction+' - position:'+position),"type":"SPA","scope":"Future of Work Trend Report"}}}});
    // window.dispatchEvent(decibelEvent);
    // console.log('Decibel tracking',decibelEvent);


  };
  function tracking_decibel(name,type,interaction,position){
    // var detailParams = { content:
    //   {
    //     'name': name,
    //     'type': type,
    //     'interaction': interaction,
    //     'position': position
    //   }
    // }
    var decibelEvent = new CustomEvent('dhl_utf_trackDecibelEvent', { bubbles: true, detail: {"decibel":{"event":{"name":(name+' - type:'+type+' - interaction:'+interaction+' - position:'+position),"type":"SPA","scope":"Future of Work Trend Report"}}}});
    window.dispatchEvent(decibelEvent);
    // console.log('Decibel tracking',decibelEvent);
    console.log('Decibel Tracking:',name+', type:'+type+' ,interaction:'+interaction+', position:'+position);
  };

  // external links
  // $('#fowtr-wrapper').on('click', 'a.link-external', function(event) {
  //   tracking('External Link','Button','Click',null);
  // });


  // fullscreen popup close
  $('#fowtr-wrapper').on('click', '.fowtr-tutorial-fullscreen-close', function(event) {
    event.preventDefault();
    tracking_adobe('Full Screen Reminder Popup Close','Button','Click','First');
    tracking_decibel('Full Screen Reminder Popup Close','Button','Click','First');
  });

  // fullscreen
  // in main navigation
  $('#fowtr-wrapper').on('click', '.fowtr-fullscreen-toggle', function(event) {
    event.preventDefault();
    var detail;
    if(!$('body').hasClass('fowtr-fullscreen')){
      tracking_adobe('Enter Full Screen','Button','Click','Main Navigation');
      tracking_decibel('Enter Full Screen','Button','Click','Main Navigation');
    } else {
      tracking_adobe('Exit Full Screen','Button','Click','Main Navigation');
      tracking_decibel('Exit Full Screen','Button','Click','Main Navigation');
    }
  });
  // in the popup
  $('#fowtr-wrapper').on('click', '.fowtr-tutorial-fullscreen-toggle', function(event) {
    event.preventDefault();
    var detail;
    if(!$('body').hasClass('fowtr-fullscreen')){
      tracking_adobe('Enter Full Screen','Button','Click','Full Screen Reminder Popup');
      tracking_decibel('Enter Full Screen','Button','Click','Full Screen Reminder Popup');
    } else {
      tracking_adobe('Exit Full Screen','Button','Click','Full Screen Reminder Popup');
      tracking_decibel('Exit Full Screen','Button','Click','Full Screen Reminder Popup');
    }
  });



  // part 2 available now popup
  $('#fowtr-wrapper').on('click', '.fowtr-tutorial-part2-release-close', function(event) {
    event.preventDefault();
    tracking_adobe('Part 2 Available Now Popup Close','Button','Click','First');
    tracking_decibel('Part 2 Available Now Popup Close','Button','Click','First');
  });
  // part 2 available now popup
  $('#fowtr-wrapper').on('click', '.fowtr-tutorial-part-2-release .fowtr-load-chapter', function(event) {
    event.preventDefault();
    var chapter = $(this).attr('data-fowtr-chapter');
    tracking_adobe('Part 2 Available Now Popup Load Chapter','Button','Click','Chapter '+chapter);
    tracking_decibel('Part 2 Available Now Popup Load Chapter','Button','Click','Chapter '+chapter);
  });


  // chapter 3 and 4 popups
  // $('#fowtr-wrapper').on('click', '.fowtr-coming-soon[data-fowtr-modal="fowtr-coming-soon-modal-chapter3"]', function(event) {
  //   event.preventDefault();
  //   tracking_adobe('Chapter Coming Soon','Button','Click','Chapter 3');
  //   tracking_decibel('Chapter Coming Soon','Button','Click','Chapter 3');
  // });
  // $('#fowtr-wrapper').on('click', '.fowtr-coming-soon[data-fowtr-modal="fowtr-coming-soon-modal-chapter4"]', function(event) {
  //   event.preventDefault();
  //   tracking_adobe('Chapter Coming Soon','Button','Click','Chapter 4');
  //   tracking_decibel('Chapter Coming Soon','Button','Click','Chapter 4');
  // });





  // chapter loading
  // $("#fowtr-wrapper").on('click','.fowtr-load-chapter', function(e) {
  //   event.preventDefault();
  //   var chapter = $(this).attr('data-fowtr-chapter');
  //   var position;
  //   if($(this).parent().hasClass('fowtr-navigation-panel-content')){
  //     position = 'Main Navigation';
  //   } else {
  //     position = 'Chapter Summary';
  //   }
  //   // tracking_adobe('Load chapter '+chapter,'Button','Click',position);
  //   tracking_decibel('Load chapter '+chapter,'Button','Click',position);
  // });





  // scrolldowns
  $('#fowtr-wrapper').on('click', '#fowtr-chapter1 .fowtr-scrolldown, #fowtr-chapter1 .fowtr-section-scrolldown', function(event) {
    event.preventDefault();
    var to = $(this).attr('href');
    to = to.replace('#fowtr-article','');
    var eq = $(this).index();
    // tracking_adobe('Scroll to chapter 1 section '+to,'Button','Click',eq);
    // tracking_decibel('Scroll to chapter 1 section '+to,'Button','Click',eq);
    tracking_adobe('Scroll to Chapter Section','Button','Click','Chapter 1 Section '+to);
    tracking_decibel('Scroll to Chapter Section','Button','Click','Chapter 1 Section '+to);
  });
  $('#fowtr-wrapper').on('click', '#fowtr-chapter2 .fowtr-scrolldown, #fowtr-chapter2 .fowtr-section-scrolldown', function(event) {
    event.preventDefault();
    var to = $(this).attr('href');
    to = to.replace('#fowtr-article','');
    var eq = $(this).index();
    tracking_adobe('Scroll to chapter section','Button','Click','Chapter 2 Section '+to);
    tracking_decibel('Scroll to chapter section','Button','Click','Chapter 2 Section '+to);
  });
  $('#fowtr-wrapper').on('click', '#fowtr-chapter3 .fowtr-scrolldown, #fowtr-chapter3 .fowtr-section-scrolldown', function(event) {
    event.preventDefault();
    var to = $(this).attr('href');
    to = to.replace('#fowtr-article','');
    var eq = $(this).index();
    tracking_adobe('Scroll to chapter section','Button','Click','Chapter 3 Section '+to);
    tracking_decibel('Scroll to chapter section','Button','Click','Chapter 3 Section '+to);
  });
  $('#fowtr-wrapper').on('click', '#fowtr-chapter4 .fowtr-scrolldown, #fowtr-chapter4 .fowtr-section-scrolldown', function(event) {
    event.preventDefault();
    var to = $(this).attr('href');
    to = to.replace('#fowtr-article','');
    var eq = $(this).index();
    tracking_adobe('Scroll to chapter section','Button','Click','Chapter 4 Section '+to);
    tracking_decibel('Scroll to chapter section','Button','Click','Chapter 4 Section '+to);
  });



  // chapter 1 article 6 navigation bits
  $('#fowtr-wrapper').on('click', '#fowtr-chapter1 #fowtr-article6 .card1', function(event) {
    event.preventDefault();
    tracking_adobe('Shifting Demographics','Button','Click','First');
    tracking_decibel('Shifting Demographics','Button','Click','First');
  });
  $('#fowtr-wrapper').on('click', '#fowtr-chapter1 #fowtr-article6 .card2', function(event) {
    event.preventDefault();
    tracking_adobe('Technology Advancement','Button','Click','First');
    tracking_decibel('Technology Advancement','Button','Click','First');
  });
  $('#fowtr-wrapper').on('click', '#fowtr-chapter1 #fowtr-article6 .card3', function(event) {
    event.preventDefault();
    tracking_adobe('Covid-19 Pandemic','Button','Click','First');
    tracking_decibel('Covid-19 Pandemic','Button','Click','First');
  });

  // chapter 3 article 6 navigation bits
  $('#fowtr-wrapper').on('click', '#fowtr-chapter3 #fowtr-article5 .card1', function(event) {
    event.preventDefault();
    tracking_adobe('Augmented Workforce','Button','Click','First');
    tracking_decibel('Augmented Workforce','Button','Click','First');
  });
  $('#fowtr-wrapper').on('click', '#fowtr-chapter3 #fowtr-article5 .card2', function(event) {
    event.preventDefault();
    tracking_adobe('Automated Workplace','Button','Click','First');
    tracking_decibel('Automated Workplace','Button','Click','First');
  });
  $('#fowtr-wrapper').on('click', '#fowtr-chapter3 #fowtr-article5 .card3', function(event) {
    event.preventDefault();
    tracking_adobe('Future Foreseen','Button','Click','First');
    tracking_decibel('Future Foreseen','Button','Click','First');
  });

  // chapter 4 article 5 navigation bits
  $('#fowtr-wrapper').on('click', '#fowtr-chapter4 #fowtr-article5 .card1', function(event) {
    event.preventDefault();
    tracking_adobe('New Leadership & Roles','Button','Click','First');
    tracking_decibel('New Leadership & Roles','Button','Click','First');
  });
  $('#fowtr-wrapper').on('click', '#fowtr-chapter4 #fowtr-article5 .card2', function(event) {
    event.preventDefault();
    tracking_adobe('New Learning & Development','Button','Click','First');
    tracking_decibel('New Learning & Development','Button','Click','First');
  });
  $('#fowtr-wrapper').on('click', '#fowtr-chapter4 #fowtr-article5 .card3', function(event) {
    event.preventDefault();
    tracking_adobe('New Work Models & Environment','Button','Click','First');
    tracking_decibel('New Work Models & Environment','Button','Click','First');
  });


  // Shifting Demographics panels external links
  $('#fowtr-wrapper').on('click', '#fowtr-chapter1 #fowtr-article11 .content-panel .content a', function(event) {
    var name = $(this).attr('data-tracking-external-link');
    var index = $(this).parent().parent().parent().index();
    tracking_adobe(name + ' External Link','Link','Click','Shifting Demographics Panel '+(index+1));
    tracking_decibel(name + ' External Link','Link','Click','Shifting Demographics Panel '+(index+1));
  });
  // Technology Advancement panels external links
  $('#fowtr-wrapper').on('click', '#fowtr-chapter1 #fowtr-article14 .content-panel .content a', function(event) {
    var name = $(this).attr('data-tracking-external-link');
    var index = $(this).parent().parent().parent().index();
    tracking_adobe(name + ' External Link','Link','Click','Technology Advancement Panel '+(index+1));
    tracking_decibel(name + ' External Link','Link','Click','Technology Advancement Panel '+(index+1));
  });





  // CHAPTER 2


  // article 6 chart selector
  $('#fowtr-wrapper').on('click', '#fowtr-chapter2 #fowtr-article6 .chart-selector .selector1', function(event) {
    // tracking_adobe('Chapter 2 section 6 chart selector','Button','Click','1');
    tracking_decibel('Chapter 2 Section 6 Chart Selector','Button','Click','1');
  });
  $('#fowtr-wrapper').on('click', '#fowtr-chapter2 #fowtr-article6 .chart-selector .selector2', function(event) {
    // tracking_adobe('Chapter 2 section 6 chart selector','Button','Click','2');
    tracking_decibel('Chapter 2 Section 6 Chart Selector','Button','Click','2');
  });


  // article 9 chart selector
  $('#fowtr-wrapper').on('click', '#fowtr-chapter2 #fowtr-article9 .chart-selector .selector1', function(event) {
    // tracking_adobe('Chapter 2 section 9 chart selector','Button','Click','1');
    tracking_decibel('Chapter 2 Section 9 Chart Selector','Button','Click','1');
  });
  $('#fowtr-wrapper').on('click', '#fowtr-chapter2 #fowtr-article9 .chart-selector .selector2', function(event) {
    // tracking_adobe('Chapter 2 section 9 chart selector','Button','Click','2');
    tracking_decibel('Chapter 2 Section 9 Chart Selector','Button','Click','2');
  });


  // article 14 chart selector
  $('#fowtr-wrapper').on('click', '#fowtr-chapter2 #fowtr-article14 .chart-selector .selector1', function(event) {
    // tracking_adobe('Chapter 2 section 14 Chart Selector','Button','Click','1');
    tracking_decibel('Chapter 2 Section 14 Chart Selector','Button','Click','1');
  });
  $('#fowtr-wrapper').on('click', '#fowtr-chapter2 #fowtr-article14 .chart-selector .selector2', function(event) {
    // tracking_adobe('Chapter 2 Section 14 Chart Selector','Button','Click','2');
    tracking_decibel('Chapter 2 Section 14 Chart Selector','Button','Click','2');
  });
  $('#fowtr-wrapper').on('click', '#fowtr-chapter2 #fowtr-article14 .chart-selector .selector3', function(event) {
    // tracking_adobe('Chapter 2 Section 14 Chart Selector','Button','Click','3');
    tracking_decibel('Chapter 2 Section 14 Chart Selector','Button','Click','3');
  });
  $('#fowtr-wrapper').on('click', '#fowtr-chapter2 #fowtr-article14 .chart-selector .selector4', function(event) {
    // tracking_adobe('Chapter 2 Section 14 Chart Selector','Button','Click','4');
    tracking_decibel('Chapter 2 Section 14 Chart Selector','Button','Click','4');
  });


  //summary
  $('#fowtr-wrapper').on('click', '#fowtr-chapter4 #fowtr-article28 .fowtr-signup', function(event) {
    tracking_adobe('Summary Signup','Button','Click','First');
    tracking_decibel('Summary Signup','Button','Click','First');
  });
  $('#fowtr-wrapper').on('click', '#fowtr-chapter4 #fowtr-article28 .fowtr-survey', function(event) {
    tracking_adobe('Summary Survey','Button','Click','First');
    tracking_decibel('Summary Survey','Button','Click','First');
  });



  // map nodes
  $('#fowtr-wrapper').on('click', '#fowtr-chapter2 #fowtr-article6 .map-node', function(event) {
    var nodeId = $(this).attr('data-node-id');
    // tracking_adobe('Chapter 2 Section 6 Chart Node Interaction','Button','Click',nodeId);
    tracking_decibel('Chapter 2 Section 6 Chart Node Interaction','Button','Click',nodeId);
  });
  $('#fowtr-wrapper').on('mouseenter', '#fowtr-chapter2 #fowtr-article6 .map-node', function(event) {
    var nodeId = $(this).attr('data-node-id');
    // tracking_adobe('Chapter 2 Section 6 Chart Node Interaction','Button','Hover',nodeId);
    tracking_decibel('Chapter 2 Section 6 Chart Node Interaction','Button','Hover',nodeId);
  });


  //workshop tour popup and summary banner
  $('#fowtr-wrapper').on('click', '#fowtr-popup-workshop a.btn, #fowtr-chapter4 #fowtr-article28 .fowtr-workshop-signup', function(event) {
    tracking_adobe('Innovation Center Visit','Button','Click','First');
    tracking_decibel('Innovation Center Visit','Button','Click','First');
  });



  // GLOBAL


  // external links
  $('#fowtr-wrapper').on('click', 'a[data-tracking-external-link]', function(event) {
    var name = $(this).attr('data-tracking-external-link');
    tracking_adobe(name + ' External Link','Link','Click','First');
    tracking_decibel(name + ' External Link','Link','Click','First');
  });


  // internal links
  $('#fowtr-wrapper').on('click', 'a[data-tracking-internal-link]', function(event) {
    var name = $(this).attr('data-tracking-internal-link');
    tracking_adobe(name + ' Internal Link','Link','Click','First');
    tracking_decibel(name + ' Internal Link','Link','Click','First');
  });






  // social share links on DHL page
  $('body').on('click', '.addthis_sharing_toolbox .at-share-btn.at-svc-facebook', function(event) {
    tracking_adobe('AddThis Social Sharing - Facebook','Link','Click','First');
    tracking_decibel('AddThis Social Sharing - Facebook','Link','Click','First');
  });
  $('body').on('click', '.addthis_sharing_toolbox .at-share-btn.at-svc-twitter', function(event) {
    tracking_adobe('AddThis Social Sharing - Twitter','Link','Click','First');
    tracking_decibel('AddThis Social Sharing - Twitter','Link','Click','First');
  });
  $('body').on('click', '.addthis_sharing_toolbox .at-share-btn.at-svc-print', function(event) {
    tracking_adobe('AddThis Social Sharing - Print','Link','Click','First');
    tracking_decibel('AddThis Social Sharing - Print','Link','Click','First');
  });
  $('body').on('click', '.addthis_sharing_toolbox .at-share-btn.at-svc-email', function(event) {
    tracking_adobe('AddThis Social Sharing - Email','Link','Click','First');
    tracking_decibel('AddThis Social Sharing - Email','Link','Click','First');
  });
  $('body').on('click', '.addthis_sharing_toolbox .at-share-btn.at-svc-compact', function(event) {
    tracking_adobe('AddThis Social Sharing - Other','Link','Click','First');
    tracking_decibel('AddThis Social Sharing - Other','Link','Click','First');
  });
  // $('body').on('click', '.addthis_sharing_toolbox .at-expanded-menu-service-list > li', function(event) {
  //   var service = $(this).find('button').attr('aria-label');
  //   tracking_adobe('AddThis Social Sharing - '+service,'Link','Click','First');
  //   tracking_decibel('AddThis Social Sharing - '+service,'Link','Click','First');
  // });




  // AUDIO
  // see below other analytics items for audio


  // AUDIO ANALYTICS
  // when clicks play from start
  // type button
  // grouped to seconds of 10
  // use percentages instead of
  // reaches end




  // var audio = $('#fowtr-read-aloud-playbar-wrapper audio')[0];
  // var audioIsPlaying = false;
  // var totalListeningTime = 0;
  // var highestListeningTime = 0;
  // var totalListeningTimeTimer = setInterval(function(){
  //   if(audioIsPlaying) {
  //     totalListeningTime ++;
  //     // console.log('total listening time: '+totalListeningTime+' seconds');
  //     var duration = audio.duration;
  //     var pc = (100 * totalListeningTime) / audio.duration;
  //     // console.log('total listening time: '+pc+'%');
  //     if(audio.currentTime > highestListeningTime) highestListeningTime = audio.currentTime;
  //   }
  // }, 1000);

  // audio.addEventListener("play", function(e){
  //   audioIsPlaying = true;
  // });
  // audio.addEventListener("ended", function(e){
  //   audioIsPlaying = false;
  // });
  // audio.addEventListener("pause", function(e){
  //   audioIsPlaying = false;
  // });
  // audio.addEventListener("emptied", function(e){
  //   audioIsPlaying = false;
  //   highestListeningTime = 0;
  //   console.log('highestListeningTime',highestListeningTime);
  // });


  var audio = $('#fowtr-read-aloud-playbar-wrapper audio')[0];
  var highestListeningTime = 0;
  var listeningPercent = 0;

  audio.addEventListener("timeupdate", function(e){
    if(audio.currentTime==0) return;
    var duration = audio.duration;
    listeningPercent = (100 * highestListeningTime) / audio.duration;
    if(audio.currentTime > highestListeningTime) highestListeningTime = audio.currentTime;
    // console.log('listened to: '+listeningPercent+'%');

    if(!c1lt25 && listeningPercent > 25 && fowtr_module_analytics.currentChapter==1) {
      c1lt25 = true;
      tracking_adobe('Audio - Chapter 1','Media','Milestone 25%','Player');
      tracking_decibel('Audio - Chapter 1','Media','Milestone 25%','Player');
    }
    if(!c1lt50 && listeningPercent > 50 && fowtr_module_analytics.currentChapter==1) {
      c1lt50 = true;
      tracking_adobe('Audio - Chapter 1','Media','Milestone 50%','Player');
      tracking_decibel('Audio - Chapter 1','Media','Milestone 50%','Player');
    }
    if(!c1lt75 && listeningPercent > 75 && fowtr_module_analytics.currentChapter==1) {
      c1lt75 = true;
      tracking_adobe('Audio - Chapter 1','Media','Milestone 75%','Player');
      tracking_decibel('Audio - Chapter 1','Media','Milestone 75%','Player');
    }
    if(!c1lt100 && listeningPercent > 95 && fowtr_module_analytics.currentChapter==1) {
      c1lt100 = true;
      tracking_adobe('Audio - Chapter 1','Media','Milestone 100%','Player');
      tracking_decibel('Audio - Chapter 1','Media','Milestone 100%','Player');
    }

    if(!c2lt25 && listeningPercent > 25 && fowtr_module_analytics.currentChapter==2) {
      c2lt25 = true;
      tracking_adobe('Audio - Chapter 2','Media','Milestone 25%','Player');
      tracking_decibel('Audio - Chapter 2','Media','Milestone 25%','Player');
    }
    if(!c2lt50 && listeningPercent > 50 && fowtr_module_analytics.currentChapter==2) {
      c2lt50 = true;
      tracking_adobe('Audio - Chapter 2','Media','Milestone 50%','Player');
      tracking_decibel('Audio - Chapter 2','Media','Milestone 50%','Player');
    }
    if(!c2lt75 && listeningPercent > 75 && fowtr_module_analytics.currentChapter==2) {
      c2lt75 = true;
      tracking_adobe('Audio - Chapter 2','Media','Milestone 75%','Player');
      tracking_decibel('Audio - Chapter 2','Media','Milestone 75%','Player');
    }
    if(!c2lt100 && listeningPercent > 95 && fowtr_module_analytics.currentChapter==2) {
      c2lt100 = true;
      tracking_adobe('Audio - Chapter 2','Media','Milestone 100%','Player');
      tracking_decibel('Audio - Chapter 2','Media','Milestone 100%','Player');
    }

    if(!c3lt25 && listeningPercent > 25 && fowtr_module_analytics.currentChapter==3) {
      c3lt25 = true;
      tracking_adobe('Audio - Chapter 3','Media','Milestone 25%','Player');
      tracking_decibel('Audio - Chapter 3','Media','Milestone 25%','Player');
    }
    if(!c3lt50 && listeningPercent > 50 && fowtr_module_analytics.currentChapter==3) {
      c3lt50 = true;
      tracking_adobe('Audio - Chapter 3','Media','Milestone 50%','Player');
      tracking_decibel('Audio - Chapter 3','Media','Milestone 50%','Player');
    }
    if(!c3lt75 && listeningPercent > 75 && fowtr_module_analytics.currentChapter==3) {
      c3lt75 = true;
      tracking_adobe('Audio - Chapter 3','Media','Milestone 75%','Player');
      tracking_decibel('Audio - Chapter 3','Media','Milestone 75%','Player');
    }
    if(!c3lt100 && listeningPercent > 99 && fowtr_module_analytics.currentChapter==3) {
      c3lt100 = true;
      tracking_adobe('Audio - Chapter 3','Media','Milestone 100%','Player');
      tracking_decibel('Audio - Chapter 3','Media','Milestone 100%','Player');
    }

    if(!c4lt25 && listeningPercent > 25 && fowtr_module_analytics.currentChapter==4) {
      c4lt25 = true;
      tracking_adobe('Audio - Chapter 4','Media','Milestone 25%','Player');
      tracking_decibel('Audio - Chapter 4','Media','Milestone 25%','Player');
    }
    if(!c4lt50 && listeningPercent > 50 && fowtr_module_analytics.currentChapter==4) {
      c4lt50 = true;
      tracking_adobe('Audio - Chapter 4','Media','Milestone 50%','Player');
      tracking_decibel('Audio - Chapter 4','Media','Milestone 50%','Player');
    }
    if(!c4lt75 && listeningPercent > 75 && fowtr_module_analytics.currentChapter==4) {
      c4lt75 = true;
      tracking_adobe('Audio - Chapter 4','Media','Milestone 75%','Player');
      tracking_decibel('Audio - Chapter 4','Media','Milestone 75%','Player');
    }
    if(!c4lt100 && listeningPercent > 99 && fowtr_module_analytics.currentChapter==4) {
      c4lt100 = true;
      tracking_adobe('Audio - Chapter 4','Media','Milestone 100%','Player');
      tracking_decibel('Audio - Chapter 4','Media','Milestone 100%','Player');
    }



  });

  // audio.addEventListener("emptied", function(e){
  //   // if(highestListeningTime>0){
  //   //   tracking_adobe('Audio - Chapter '+fowtr_module_analytics.currentChapter+'','Media','Listened to: '+listeningPercent+'%','Player');
  //   //   tracking_decibel('Audio - Chapter '+fowtr_module_analytics.currentChapter+'','Media','Listened to: '+listeningPercent+'%','Player');
  //   // }
  //   highestListeningTime = 0;
  // });

  var c1lt25 = false;
  var c1lt50 = false;
  var c1lt75 = false;
  var c1lt100 = false;

  var c2lt25 = false;
  var c2lt50 = false;
  var c2lt75 = false;
  var c2lt100 = false;

  var c3lt25 = false;
  var c3lt50 = false;
  var c3lt75 = false;
  var c3lt100 = false;

  var c4lt25 = false;
  var c4lt50 = false;
  var c4lt75 = false;
  var c4lt100 = false;

  audio.addEventListener("emptied", function(e){
    audioIsPlaying = false;
    highestListeningTime = 0;
      
    c1lt25 = false;
    c1lt50 = false;
    c1lt75 = false;
    c1lt100 = false;

    c2lt25 = false;
    c2lt50 = false;
    c2lt75 = false;
    c2lt100 = false;

    c3lt25 = false;
    c3lt50 = false;
    c3lt75 = false;
    c3lt100 = false;

    c4lt25 = false;
    c4lt50 = false;
    c4lt75 = false;
    c4lt100 = false;

  });


  // audio.addEventListener("timeupdate", function(e){

  // });
  // $(window).on('beforeunload', function(){
    // audio.duration;
    // tracking_adobe('Total audio listening time','Audio','Play',totalListeningTime);
    // tracking_decibel('Total audio listening time','Audio','Play',totalListeningTime);
  // });


  $('#fowtr-wrapper #fowtr-read-aloud-playbar-wrapper').on('click', 'a.previous', function(event) {
    tracking_adobe('Audio - Chapter '+fowtr_module_analytics.currentChapter+'','Media','Previous Chapter','Player');
    tracking_decibel('Audio - Chapter '+fowtr_module_analytics.currentChapter+'','Media','Previous Chapter','Player');
  });
  $('#fowtr-wrapper #fowtr-read-aloud-playbar-wrapper').on('click', 'a.next', function(event) {
    tracking_adobe('Audio - Chapter '+fowtr_module_analytics.currentChapter+'','Media','Next Chapter','Player');
    tracking_decibel('Audio - Chapter '+fowtr_module_analytics.currentChapter+'','Media','Next Chapter','Player');
  });
  $('#fowtr-wrapper #fowtr-read-aloud-playbar-wrapper').on('click', 'a.play', function(event) {
    if($('#fowtr-wrapper').hasClass('reading-aloud')){
      tracking_adobe('Audio - Chapter '+fowtr_module_analytics.currentChapter+'','Media','Pause','Player');
      tracking_decibel('Audio - Chapter '+fowtr_module_analytics.currentChapter+'','Media','Pause','Player');
    } else {
      tracking_adobe('Audio - Chapter '+fowtr_module_analytics.currentChapter+'','Media','Play','Player');
      tracking_decibel('Audio - Chapter '+fowtr_module_analytics.currentChapter+'','Media','Play','Player');
    }
  });
  $('#fowtr-wrapper #fowtr-read-aloud-playbar-wrapper').on('click', 'a.playlist', function(event) {
    tracking_adobe('Audio - Chapter '+fowtr_module_analytics.currentChapter+'','Media','Open Playlist','Player');
    tracking_decibel('Audio - Chapter '+fowtr_module_analytics.currentChapter+'','Media','Open Playlist','Player');
  });
  $('#fowtr-wrapper #fowtr-read-aloud-playbar-wrapper .playlist-nav .inner').on('click', 'a', function(event) {
    var name = $(this).find('span').html();
    // tracking_adobe('Audio - Chapter '+fowtr_module_analytics.currentChapter+' - clicked playlist item: ' + name,'Media','Click','First');
    tracking_decibel('Audio - Chapter '+fowtr_module_analytics.currentChapter+' - Clicked Playlist Item','Media','Click',name);
  });

  //see above for analytics that are in the navigation!!!!
  $('#fowtr-wrapper').on('click', '#fowtr-navigation .fowtr-read-from a.from_current', function(event) {
    tracking_adobe('Audio - Chapter '+fowtr_module_analytics.currentChapter,'Media','Click','Play From Chapter '+ fowtr_module_analytics.currentSectionInView);
    tracking_decibel('Audio - Chapter '+fowtr_module_analytics.currentChapter,'Media','Click','Play From Chapter '+ fowtr_module_analytics.currentSectionInView);
  });
  $('#fowtr-wrapper').on('click', '#fowtr-navigation .fowtr-read-from a.from_start', function(event) {
    tracking_adobe('Audio - Chapter '+fowtr_module_analytics.currentChapter,'Media','Click','Play From Start');
    tracking_decibel('Audio - Chapter '+fowtr_module_analytics.currentChapter,'Media','Click','Play From Start');
  });

  $('#fowtr-wrapper').on('click', '.fowtr-read-section-aloud', function(event) {
    var article = $(this).parent().attr('id').replace('fowtr-article','');
    tracking_adobe('Audio - Chapter '+fowtr_module_analytics.currentChapter+'','Media','Listen From Here','Section '+article);
    tracking_decibel('Audio - Chapter '+fowtr_module_analytics.currentChapter+'','Media','Listen From Here','Section '+article);
  });

  $('#fowtr-wrapper').on('click', '.fowtr-audio-download-links a', function(event) {
    var platform = $(this).attr('data-audio-platform');
    tracking_adobe('Listen on '+platform,'Link','Click','First');
    tracking_decibel('Listen on '+platform,'Link','Click','First');
  });

  $('#fowtr-wrapper #fowtr-read-aloud-playbar-wrapper').on('change, input', '.auto-scroll #auto-scroll-toggle', function(event) {
    var as;
    if ($(this).is(':checked')) {
      as = 'Enable';
    } else {
      as = 'Disable';
    }
    // tracking_adobe('Audio - Chapter '+fowtr_module_analytics.currentChapter+' - Autoscroll','Media','Click',as);
    tracking_decibel('Audio - Chapter '+fowtr_module_analytics.currentChapter+' - Autoscroll','Media','Click',as);
  });










  fowtr_module_analytics.currentSectionInView = 0;
  var firstRun = true;

  fowtr_module_analytics.init = function(chapter) {
    fowtr_module_analytics.currentChapter = chapter;

    console.log('dataLayer.page.pageInfo.pageName','Future of Work Interactive Report | Chapter '+chapter+' | DHL');
    try {
      dataLayer.page.pageInfo.pageName = 'Future of Work Interactive Report | Chapter '+chapter+' | DHL';
      // disabled the feedback tab on the page
      // dataLayer.flags.survey.disableGlobalFeedbackElement = false;
    } catch(e) {
      console.warn('Tracking dataLayer not found');
    }

    // page view
    if(!firstRun) {
      var event = new CustomEvent('dhl_utf_pageload', { bubbles: true });
      window.dispatchEvent(event);
      console.log('dhl_utf_pageload event triggered');
    }
    firstRun = false;



    // inview on each section - delay in case jumping to a section by URL
    setTimeout(function(){
      // when scrolling to articles
      // $.each($('#fowtr-wrapper #fowtr-chapter1 article > div'), function(index, val) {
      //    $(this).one('inview', function(event, visible) {
      //        // event.stopPropagation();
      //        if(!$(event.target).is(this)) return;
      //        if (visible) {
      //           var id = $(this).attr('id');
      //           if(id){
      //             id = id.replace('fowtr-article','');
      //             fowtr_module_analytics.currentSectionInView = id;
      //             tracking_adobe('Viewed chapter 1 section','Section','View',id);
      //             tracking_decibel('Viewed chapter 1 section','Section','View',id);
      //           }
      //        } else {
      //         // hidden
      //        }
      //    });
      // });
      // $.each($('#fowtr-wrapper #fowtr-chapter2 article > div'), function(index, val) {
      //    $(this).one('inview', function(event, visible) {
      //        // event.stopPropagation();
      //        if(!$(event.target).is(this)) return;
      //        if (visible) {
      //           var id = $(this).attr('id');
      //           if(id){
      //             id = id.replace('fowtr-article','');
      //             fowtr_module_analytics.currentSectionInView = id;
      //             tracking_adobe('Viewed chapter 2 section','Section','View',id);
      //             tracking_decibel('Viewed chapter 2 section','Section','View',id);
      //           }
      //        } else {
      //         // hidden
      //        }
      //    });
      // });






      // $.each($('#fowtr-wrapper #fowtr-chapter1 .fowtr-analytics-view-trigger'), function(index, val) {
      //    $(this).one('inview', function(event, visible) {
      //        // event.stopPropagation();
      //        // if(!$(event.target).is(this)) return;
      //        if (visible) {
      //           // var id = $(this).next().attr('id');
      //           var id = $(this).attr('data-section');
      //           if(id){
      //             id = id.replace('fowtr-article','');
      //             fowtr_module_analytics.currentSectionInView = id;
      //             // tracking_adobe('Viewed chapter 1 section','Section','View',id);
      //             // tracking_decibel('Viewed chapter 1 section','Section','View',id);
      //           }
      //        } else {
      //         // hidden
      //        }
      //    });
      // });
      // $.each($('#fowtr-wrapper #fowtr-chapter2 .fowtr-analytics-view-trigger'), function(index, val) {
      //    $(this).one('inview', function(event, visible) {
      //        // event.stopPropagation();
      //        // if(!$(event.target).is(this)) return;
      //        if (visible) {
      //           // var id = $(this).next().attr('id');
      //           var id = $(this).attr('data-section');
      //           if(id){
      //             id = id.replace('fowtr-article','');
      //             fowtr_module_analytics.currentSectionInView = id;
      //             // tracking_adobe('Viewed chapter 2 section','Section','View',id);
      //             // tracking_decibel('Viewed chapter 2 section','Section','View',id);
      //           }
      //        } else {
      //         // hidden
      //        }
      //    });
      // });
      // $.each($('#fowtr-wrapper #fowtr-chapter3 .fowtr-analytics-view-trigger'), function(index, val) {
      //    $(this).one('inview', function(event, visible) {
      //        // event.stopPropagation();
      //        // if(!$(event.target).is(this)) return;
      //        if (visible) {
      //           // var id = $(this).next().attr('id');
      //           var id = $(this).attr('data-section');
      //           if(id){
      //             id = id.replace('fowtr-article','');
      //             fowtr_module_analytics.currentSectionInView = id;
      //             // tracking_adobe('Viewed chapter 2 section','Section','View',id);
      //             // tracking_decibel('Viewed chapter 2 section','Section','View',id);
      //           }
      //        } else {
      //         // hidden
      //        }
      //    });
      // });
      // $.each($('#fowtr-wrapper #fowtr-chapter4 .fowtr-analytics-view-trigger'), function(index, val) {
      //    $(this).one('inview', function(event, visible) {
      //        // event.stopPropagation();
      //        // if(!$(event.target).is(this)) return;
      //        if (visible) {
      //           // var id = $(this).next().attr('id');
      //           var id = $(this).attr('data-section');
      //           if(id){
      //             id = id.replace('fowtr-article','');
      //             fowtr_module_analytics.currentSectionInView = id;
      //             // tracking_adobe('Viewed chapter 2 section','Section','View',id);
      //             // tracking_decibel('Viewed chapter 2 section','Section','View',id);
      //           }
      //        } else {
      //         // hidden
      //        }
      //    });
      // });








      // removed as now only used for trying to keep section in view when going full screen.
      // that function is now using the getArticleClosestToCenter in utilities
      
      // // global to cover all now we're not tracking this
      // $.each($('#fowtr-wrapper .fowtr-analytics-view-trigger'), function(index, val) {
      //    $(this).one('inview', function(event, visible) {
      //        // event.stopPropagation();
      //        // if(!$(event.target).is(this)) return;
      //        if (visible) {
      //           // var id = $(this).next().attr('id');
      //           var id = $(this).attr('data-section');
      //           if(id){
      //             id = id.replace('fowtr-article','');
      //             fowtr_module_analytics.currentSectionInView = id;
      //             console.log('currentSectionInView',fowtr_module_analytics.currentSectionInView);
      //             // tracking_adobe('Viewed chapter 2 section','Section','View',id);
      //             // tracking_decibel('Viewed chapter 2 section','Section','View',id);
      //           }
      //        } else {
      //         // hidden
      //        }
      //    });
      // });



      // chapter 3 slider
      if($('#fowtr-chapter3 #fowtr-article11 .fowtr-slider').length) {
        fowtr_module_chapter_3.slider.events.on('indexChanged', function(info, eventName) {
          if(info.index>6 || info.index<=0) return;
          tracking_adobe('Chapter 3 section 11 Slider','Button','Click',info.index);
          tracking_decibel('Chapter 3 Section 11 Slider','Button','Click',info.index);
        });
      }

      // chapter 4 slider
      if($('#fowtr-chapter4 #fowtr-article10 .fowtr-slider').length) {
        fowtr_module_chapter_4.slider.events.on('indexChanged', function(info, eventName) {
          if(info.index>3 || info.index<=0) return;
          tracking_adobe('Chapter 4 section 10 Slider','Button','Click',info.index);
          tracking_decibel('Chapter 4 Section 10 Slider','Button','Click',info.index);
        });
      }









    },1000);


  }; //end init




  fowtr_module_analytics.c4_article11_video_Loaded = function(video){

    var video = $('#fowtr-chapter4 #fowtr-article11 #fowtr-article11-video-container video')[0];

    var highestWatchingTime = 0;
    var watchedPercent = 0;
    var article11v25 = false;
    var article11v50 = false;
    var article11v75 = false;
    var article11v100 = false;

    video.addEventListener("timeupdate", function(e){
      // console.log('watchedPercent',watchedPercent);
      if(video.currentTime==0) return;
      var duration = video.duration;
      watchedPercent = (100 * highestWatchingTime) / video.duration;
      if(video.currentTime > highestWatchingTime) highestWatchingTime = video.currentTime;
      // console.log('listened to: '+watchedPercent+'%');

      if(!article11v25 && watchedPercent > 25 && fowtr_module_analytics.currentChapter==4) {
        article11v25 = true;
        tracking_adobe('Video - Practical Insights on Jobs','Media','Milestone 25%','Player');
        tracking_decibel('Video - Practical Insights on Jobs','Media','Milestone 25%','Player');
      }
      if(!article11v50 && watchedPercent > 50 && fowtr_module_analytics.currentChapter==4) {
        article11v50 = true;
        tracking_adobe('Video - Practical Insights on Jobs','Media','Milestone 50%','Player');
        tracking_decibel('Video - Practical Insights on Jobs','Media','Milestone 50%','Player');
      }
      if(!article11v75 && watchedPercent > 75 && fowtr_module_analytics.currentChapter==4) {
        article11v75 = true;
        tracking_adobe('Video - Practical Insights on Jobs','Media','Milestone 75%','Player');
        tracking_decibel('Video - Practical Insights on Jobs','Media','Milestone 75%','Player');
      }
      if(!article11v100 && watchedPercent > 99 && fowtr_module_analytics.currentChapter==4) {
        article11v100 = true;
        tracking_adobe('Video - Practical Insights on Jobs','Media','Milestone 100%','Player');
        tracking_decibel('Video - Practical Insights on Jobs','Media','Milestone 100%','Player');
      }
    });

    // var firstPlay = true;
    video.addEventListener("play", function(e){
      // if(!firstPlay) return;
      tracking_adobe('Video - Practical Insights on Jobs','Media','Play','Player');
      tracking_decibel('Video - Practical Insights on Jobs','Media','Play','Player');
      // firstPlay = false;
    });

    video.addEventListener("emptied", function(e){
      audioIsPlaying = false;
      highestWatchingTime = 0;
      console.log('video watch analytics reset');  
      article11v25 = false;
      article11v50 = false;
      article11v75 = false;
      article11v100 = false;
    });

  };//end video loaded function



  fowtr_module_analytics.c4_article20_video_Loaded = function(video){

    var video = $('#fowtr-chapter4 #fowtr-article20 #fowtr-article20-video-container video')[0];

    var highestWatchingTime = 0;
    var watchedPercent = 0;
    var article20v25 = false;
    var article20v50 = false;
    var article20v75 = false;
    var article20v100 = false;

    video.addEventListener("timeupdate", function(e){
      // console.log('watchedPercent',watchedPercent);
      if(video.currentTime==0) return;
      var duration = video.duration;
      watchedPercent = (100 * highestWatchingTime) / video.duration;
      if(video.currentTime > highestWatchingTime) highestWatchingTime = video.currentTime;
      // console.log('listened to: '+watchedPercent+'%');

      if(!article20v25 && watchedPercent > 25 && fowtr_module_analytics.currentChapter==4) {
        article20v25 = true;
        tracking_adobe('Video - Digital Diversity In The Workplace','Media','Milestone 25%','Player');
        tracking_decibel('Video - Digital Diversity In The Workplace','Media','Milestone 25%','Player');
      }
      if(!article20v50 && watchedPercent > 50 && fowtr_module_analytics.currentChapter==4) {
        article20v50 = true;
        tracking_adobe('Video - Digital Diversity In The Workplace','Media','Milestone 50%','Player');
        tracking_decibel('Video - Digital Diversity In The Workplace','Media','Milestone 50%','Player');
      }
      if(!article20v75 && watchedPercent > 75 && fowtr_module_analytics.currentChapter==4) {
        article20v75 = true;
        tracking_adobe('Video - Digital Diversity In The Workplace','Media','Milestone 75%','Player');
        tracking_decibel('Video - Digital Diversity In The Workplace','Media','Milestone 75%','Player');
      }
      if(!article20v100 && watchedPercent > 99 && fowtr_module_analytics.currentChapter==4) {
        article20v100 = true;
        tracking_adobe('Video - Digital Diversity In The Workplace','Media','Milestone 100%','Player');
        tracking_decibel('Video - Digital Diversity In The Workplace','Media','Milestone 100%','Player');
      }
    });

    // var firstPlay = true;
    video.addEventListener("play", function(e){
      // if(!firstPlay) return;
      tracking_adobe('Video - Digital Diversity In The Workplace','Media','Play','Player');
      tracking_decibel('Video - Digital Diversity In The Workplace','Media','Play','Player');
      // firstPlay = false;
    });

    video.addEventListener("emptied", function(e){
      audioIsPlaying = false;
      highestWatchingTime = 0;
      console.log('video watch analytics reset');  
      article20v25 = false;
      article20v50 = false;
      article20v75 = false;
      article20v100 = false;
    });

  };//end video loaded function




  fowtr_module_analytics.tracking_adobe = function(name,type,interaction,position){
    tracking_adobe('Video - Digital Diversity In The Workplace','Media','Play','Player');
  };
  fowtr_module_analytics.tracking_decibel = function(name,type,interaction,position){
    tracking_adobe('Video - Digital Diversity In The Workplace','Media','Play','Player');
  };




  fowtr_module_analytics.destroy = function(chapter){
    console.log('destroy chapter analytics '+chapter);
  };//end destroy function


  return fowtr_module_analytics;
}(fowtr_module_analytics || {}));